<template>
  <div class="elite-tabs-wrapper-content">
    <div class="custom-header">
      <h3>
        {{ `${estimate.code}` }} -
        {{ $t("COMMON.LOGS") }}
      </h3>
    </div>
    <log-list-table :filterSubject="estimate" />
  </div>
</template>
<script>
import LogListTable from "@/views/Pages/DefaultModule/LogManagement/partials/LogListTable.vue";

export default {
  name: "estimate-view-logs",

  components: { LogListTable },

  props: ["estimate"],

  mixins: [],

  data() {
    return {};
  },

  computed: {},

  methods: {},

  mounted() {},

  watch: {
    user(user) {},
  },
};
</script>
